import { createSelector } from 'reselect';

import IState from 'types/Istore';

export const tradingViewChartSelector = (state: IState) => state.tradingView;

export const markPriceChartSelector = createSelector(
  [tradingViewChartSelector],
  tv => tv.markPriceChart
);

export const chartActiveTabSelector = createSelector(
  [tradingViewChartSelector],
  tv => tv.activeTab
);
